/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BridgeApiConversationStatus } from './BridgeApiConversationStatus';
import {
    BridgeApiConversationStatusFromJSON,
    BridgeApiConversationStatusFromJSONTyped,
    BridgeApiConversationStatusToJSON,
    BridgeApiConversationStatusToJSONTyped,
} from './BridgeApiConversationStatus';

/**
 * a Conversation Counterparty
 * @export
 * @interface BridgeApiConversationCounterparty
 */
export interface BridgeApiConversationCounterparty {
    /**
     * 
     * @type {number}
     * @memberof BridgeApiConversationCounterparty
     */
    organisationId?: number;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversationCounterparty
     */
    organisationHandle?: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversationCounterparty
     */
    organisationName?: string;
    /**
     * 
     * @type {BridgeApiConversationStatus}
     * @memberof BridgeApiConversationCounterparty
     */
    status: BridgeApiConversationStatus;
}



/**
 * Check if a given object implements the BridgeApiConversationCounterparty interface.
 */
export function instanceOfBridgeApiConversationCounterparty(value: object): value is BridgeApiConversationCounterparty {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function BridgeApiConversationCounterpartyFromJSON(json: any): BridgeApiConversationCounterparty {
    return BridgeApiConversationCounterpartyFromJSONTyped(json, false);
}

export function BridgeApiConversationCounterpartyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiConversationCounterparty {
    if (json == null) {
        return json;
    }
    return {
        
        'organisationId': json['organisationId'] == null ? undefined : json['organisationId'],
        'organisationHandle': json['organisationHandle'] == null ? undefined : json['organisationHandle'],
        'organisationName': json['organisationName'] == null ? undefined : json['organisationName'],
        'status': BridgeApiConversationStatusFromJSON(json['status']),
    };
}

export function BridgeApiConversationCounterpartyToJSON(json: any): BridgeApiConversationCounterparty {
    return BridgeApiConversationCounterpartyToJSONTyped(json, false);
}

export function BridgeApiConversationCounterpartyToJSONTyped(value?: BridgeApiConversationCounterparty | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organisationId': value['organisationId'],
        'organisationHandle': value['organisationHandle'],
        'organisationName': value['organisationName'],
        'status': BridgeApiConversationStatusToJSON(value['status']),
    };
}

